"use strict";

Shopify.theme.jsVideoSliderSetup  = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsVideoSliderSetup = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
    const $mainSlider = $section.find('.jsVideoSlider')
    const $thumbSlider = $section.find('.jsVideoThumb')
    const $video = $section.find('.jsVideo')
    const numSlides = parseInt($mainSlider.data('blocks'))

    if (numSlides > 1) {
      let $slider = $mainSlider.flickity({
          pageDots: false,
          contain: true,
          adaptiveHeight:true
      })
      
      let $thumb = $thumbSlider.flickity({
        asNavFor: $mainSlider[0],
        contain: true,
        pageDots: false,
        prevNextButtons :false
      })
      $slider.on( 'change.flickity', function( event, index ) {
        if($video.length){
          $.each($video,function(ind,ele){
            let player_id = $(ele).attr('id') 
            Shopify.theme.jsVideoPlayers[player_id].pause()
          })
        }
      })

      setTimeout(function () {
        $slider.flickity('resize');
      }, 7000);
    }
    
  },
  unload: function unload($section) {
   
  }
};